import { Button, Tooltip } from "antd";
import { default as React } from "react";
import rightArrowIcon from "../../assets/icon/rightArrowIcon.svg";
import InfoAudio from "../../components/infoaudio/infoAudio";
import { HelperContext } from "../../store/helperStore";

export default function TestFooter({
  isUserInput,
  question,
  questions,
  index,
}) {
  const { _, dispatchHelper } = HelperContext();
  const handleNext = () => {
    dispatchHelper({ type: "IS_NEXT_QUES", payload: true });
  };

  let sectionName = question.section_name.toLowerCase(); // "NUMBER SEQUENCE"
  sectionName = sectionName.split(" ").join("_");
  console.log(sectionName);

  return (
    <div className="test-footer">
      {/* <div className="test-footer__one">
        <InfoAudio question={question} />
      </div> */}

      <div className="test-footer__two"></div>
      <div className="test-footer__three">
        <Tooltip title={!isUserInput && "Please input your answer first"}>
          <button
            // className="test-footer__btn-nonAudio"
            className={`custom-btn footer ${!isUserInput && "disable"}`}
            onClick={!isUserInput ? () => undefined : handleNext}
            // disabled={!isUserInput}
          >
            {index < questions.length - 1 ? "Next" : "Submit"}
            <img src={rightArrowIcon} alt="" />
          </button>
        </Tooltip>
      </div>
    </div>
  );
}
